<template>
  <div>
    <v-btn
      :loading="loading"
      @click="dialog = true"
      depressed
      color="primary"
      height="40"
      class="rounded-lg text-none body-2"
      >Создать операцию
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card class="pa-5">
        <div class="font-weight-bold">Создание операции</div>
        <v-text-field
          dense
          hide-details
          class="mt-5"
          outlined
          label="Сумма"
          type="number"
          v-model.number="data.sum"
        ></v-text-field>
        <v-text-field
          dense
          hide-details
          class="mt-3"
          outlined
          label="Сообщение пользователю"
          v-model="data.message"
        ></v-text-field>
        <v-text-field
          dense
          hide-details
          class="mt-3"
          outlined
          label="Комментарий к операции"
          v-model="data.description"
        ></v-text-field>
        <v-autocomplete
          v-model="selectedUsers"
          :loading="userLoading"
          :items="userBalance.list"
          :search-input.sync="searchUser"
          :item-text="v => (v.first_name || 'Неизвестный') + ' - ' + v.phone"
          item-value="id"
          cache-items
          class="mt-4 mb-4"
          flat
          hide-no-data
          hide-details
          multiple
          deletable-chips
          clearable
          @change="onSelect"
          small-chips
          outlined
          dense
          label="Пользователи"
        ></v-autocomplete>
        <div
          class="mt-5 primary--text text-body-2"
          v-if="settings && settings.system_settings.max_amount_for_refiled_balance !== null"
        >
          Максимальное количество для начисления:
          {{ settings.system_settings.max_amount_for_refiled_balance }}
        </div>
        <v-btn
          class="mt-5 rounded-lg"
          color="primary"
          depressed
          :disabled="
            !data.sum ||
            !data.message ||
            !data.description ||
            !settings ||
            settings.system_settings.max_amount_for_refiled_balance < data.sum ||
            selectedUsers.length == 0
          "
          :loading="$balanceOperation.loadings.save"
          @click="save"
          >Создать
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import AuthenticatorInput from '@/admin/components/AuthenticatorInput.vue'
  import { SearchUser } from '@/models/SearchUser'

  export default {
    name: 'CreateUserBalanceButton',
    comments: {
      AuthenticatorInput
    },
    props: {
      settings: Object,
      loading: Boolean,
      onSave: {
        type: Function,
        required: true
      }
    },
    data: () => {
      return {
        userLoading: true,
        userBalance: new SearchUser(),
        dialog: false,
        searchUser: '',
        selectedUsers: [],
        timeout: null,
        data: {
          sum: 0,
          message: null,
          description: null
        }
      }
    },
    watch: {
      searchUser(v) {
        if (this.timeout) clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.userBalance.loadList(
            v
              ? {
                  first_name: v
                }
              : null
          )
        }, 300)
      }
    },
    methods: {
      onSelect() {
        this.$nextTick(() => {
          this.searchUser = ''
        })
      },
      clearData() {
        this.searchUser = ''
        this.selectedUsers = []
        this.data = {
          sum: 0,
          message: null,
          description: null
        }
      },
      save() {
        const result = this.selectedUsers.map(userId => ({
          user: userId,
          sum: this.data.sum,
          message: this.data.message,
          description: this.data.description
        }))

        this.onSave(result)
        this.clearData()
      },
      close() {
        if (this.dialog) {
          this.dialog = false
        }
      }
    },
    mounted() {
      this.userBalance.loadList().finally(() => {
        this.userLoading = false
      })
    }
  }
</script>

<style scoped></style>
